import React from 'react'
import { Link } from 'react-router-dom'
import './Legal.css'

export default function Terms() {
  return (
    <div className="legal-page page-fade">
      <div className="container">
        <div className="legal-header">
          <Link to="/" className="btn btn-ghost btn-sm" style={{ marginBottom: 24 }}>← Home</Link>
          <h1>Terms of Service</h1>
          <p className="legal-meta">Last updated: May 2026</p>
        </div>
        <div className="legal-body">
          <section>
            <h2>1. Acceptance of terms</h2>
            <p>By creating an account or using HumanOrigin ("the Service"), you agree to these Terms of Service. If you do not agree, do not use the Service.</p>
          </section>
          <section>
            <h2>2. What HumanOrigin is</h2>
            <p>HumanOrigin is a platform that allows creators to document their creative process and submit their work for human review. Upon approval, a Certificate of Human Origin is issued. We do not guarantee that all submissions will be verified.</p>
          </section>
          <section>
            <h2>3. Your account</h2>
            <ul>
              <li>You must provide accurate information when creating your account.</li>
              <li>You are responsible for maintaining the security of your account.</li>
              <li>You must be at least 13 years old to use this Service.</li>
              <li>One person may not maintain multiple accounts.</li>
            </ul>
          </section>
          <section>
            <h2>4. Your content</h2>
            <ul>
              <li>You retain ownership of all content you submit to HumanOrigin.</li>
              <li>By submitting content, you grant us a licence to display it on the platform as part of your profile and certificate.</li>
              <li>You must not submit content that is AI-generated, plagiarised, or misrepresented as human-made.</li>
              <li>You must not submit content that is illegal, harmful, hateful, or infringes on third-party rights.</li>
            </ul>
          </section>
          <section>
            <h2>5. Verification</h2>
            <p>Projects are verified through community review: independent reviewers evaluate submitted evidence and cast a verdict. We reserve the right to reject or revoke verification at our discretion, including after community review, if evidence of misrepresentation is found.</p>
          </section>
          <section>
            <h2>6. Free service</h2>
            <ul>
              <li>Submitting projects, being reviewed, and holding a certificate are free.</li>
              <li>To submit your own project for review, you're required to review a small number of other projects first.</li>
              <li>All verified certificates and visibility settings are retained permanently.</li>
            </ul>
          </section>
          <section>
            <h2>7. Prohibited conduct</h2>
            <ul>
              <li>Submit AI-generated content as human-made</li>
              <li>Attempt to manipulate or deceive our review process</li>
              <li>Use the platform for spam, fraud, or illegal activity</li>
              <li>Attempt to reverse engineer or disrupt the Service</li>
            </ul>
          </section>
          <section>
            <h2>8. Termination</h2>
            <p>We reserve the right to suspend or terminate accounts that violate these terms. You may delete your account at any time by contacting us.</p>
          </section>
          <section>
            <h2>9. Limitation of liability</h2>
            <p>HumanOrigin is provided "as is". We are not liable for any indirect, incidental, or consequential damages arising from your use of the Service. Our total liability shall not exceed the amount you paid us in the 12 months preceding the claim.</p>
          </section>
          <section>
            <h2>10. Changes to these terms</h2>
            <p>We may update these terms from time to time. Continued use of the Service after changes constitutes acceptance of the new terms.</p>
          </section>
          <section>
            <h2>11. Contact</h2>
            <p>For any questions about these terms, contact us at <strong>humanorigin.app@gmail.com</strong></p>
          </section>
        </div>
      </div>
    </div>
  )
}
